import CourseSectionTable from './CourseSectionTable';

export default CourseSectionTable;
